var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCueCards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M19.5 4H5.5C3.84315 4 2.5 5.34315 2.5 7V17C2.5 18.6569 3.84315 20 5.5 20H19.5C21.1569 20 22.5 18.6569 22.5 17V7C22.5 5.34315 21.1569 4 19.5 4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10C18.6046 10 19.5 9.10457 19.5 8C19.5 6.89543 18.6046 6 17.5 6C16.3954 6 15.5 6.89543 15.5 8C15.5 9.10457 16.3954 10 17.5 10Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 16C4.5 16.2652 4.60536 16.5196 4.79289 16.7071C4.98043 16.8946 5.23478 17 5.5 17H19.5C19.7652 17 20.0196 16.8946 20.2071 16.7071C20.3946 16.5196 20.5 16.2652 20.5 16C20.5 14.636 18.812 13 18 13C17.188 13 16.452 14 14.5 14C12.058 14 10.5 9 8.5 9C6.5 9 4.5 13.362 4.5 16Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCueCards);
export default __webpack_public_path__ + "static/media/cue-cards.e27c6b86f78e33d1618907038f0d4a1f.svg";
export { ForwardRef as ReactComponent };